


















































// vendor
import { defineComponent, PropType, computed } from "@vue/composition-api";
// local
import { Information } from "../../ts/types/ItemSettings";

export default defineComponent({
	props:{
		data:{
			type:Object as PropType<Information>,
			required:true
		}
	},
	setup(props, context){

		const title = computed({
			get:() => props.data.title,
			set:v => props.data.title = v
		});

		const text = computed({
			get:() => props.data.text,
			set:v => props.data.text = v
		});

		return {
			title,
			text
		};
	}
});

